import type { ProvidersListFilters } from '@openx/components-provider/lib/components/types.ts';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';

export const adjustCriteriaFilters = (criteria: AllTableCriteria<ProvidersListFilters>) => {
  const byPhrase = {
    fields: ['id', 'name'],
    phrase: criteria.filters?.phrase ?? '',
  };

  return { byPhrase };
};
